module.exports = __webpack_public_path__ + "25d5838526865a90b7ac373b07745ad2.png";